import { useQueryClient } from "@tanstack/react-query";
import { useTrackEvent } from "contexts/tracking";
import { useEffect } from "react";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import css from "./index.module.scss";

export const FrontendVersion = () => {
  const latest = useAppSelector(authNewSelectors.frontendVersionGet);
  const queryClient = useQueryClient();
  const running = process.env.REACT_APP_COMMIT_HASH;
  const trackEvent = useTrackEvent();

  const show = Boolean(latest && running && latest !== running);

  useEffect(() => {
    if (!show) return;
    trackEvent(`frontend-version-display`, running || "-");
  }, [running, show, trackEvent]);

  useEffect(() => {
    let lastAt = Date.now();

    const handler = () => {
      if (document.visibilityState === "visible") {
        if (Date.now() - lastAt > 60 * 60 * 1000) {
          lastAt = Date.now();
          queryClient.invalidateQueries({ queryKey: ["auth-new"] });
        }
      }
    };

    document.addEventListener("visibilitychange", handler);
  }, [queryClient]);

  if (!show) {
    return null;
  }

  return (
    <div className={css.updateBanner} onClick={() => window.location.reload()}>
      Update available, <u>click here to refresh</u>.
    </div>
  );
};
